import React, { useMemo } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { SideFilter } from '_/components/side-filter'
import { Select, BasicInput } from '_/components/inputs'

import { aiAssistantsListSelector } from '_modules/ai-integration/selectors'

import { FILTER_DEFAULT_VALUES, PROMPTS_OPTIONS, STATUS_API_OPTIONS } from '../utils/constants'

import useStyles from './styles'

export const AiTrainingFilterDrawer = ({ open, close, filters, applyFilters }) => {
  const styles = useStyles()

  const assistantsList = useSelector(aiAssistantsListSelector)

  const methods = useForm({
    mode: 'all',
    defaultValues: FILTER_DEFAULT_VALUES,
  })

  const { reset, handleSubmit } = methods

  const assistantsOptions = useMemo(() => {
    const assistants = [
      { id: '', name: '(Todos)' },
      ...(assistantsList?.slice()?.sort((a, b) => a.name.localeCompare(b.name)) || []),
    ]

    return assistants
  }, [assistantsList])

  const statusOptions = useMemo(() => {
    const allOption = { value: '', label: '(Todos)' }
    const filteredOptions = STATUS_API_OPTIONS.filter(opt => opt.value !== '')
    return [allOption, ...filteredOptions]
  }, [STATUS_API_OPTIONS])

  const mainFilters = useMemo(() => {
    return (
      <>
        <div className={styles.selectContainer}>
          <Select
            label="Tipo de IA"
            name="aiAssistant"
            defaultValue={filters?.aiAssistant}
            options={assistantsOptions}
            getValue={item => item?.id}
            getLabel={item => item.name}
          />
        </div>
        <div className={styles.selectContainer}>
          <Select
            label="Prompt:"
            name="isPrompt"
            defaultValue={filters?.isPrompt}
            options={PROMPTS_OPTIONS}
            getValue={item => item?.value}
            getLabel={item => item?.label}
          />
        </div>
        <div className={styles.selectContainer}>
          <BasicInput label="Usuário contenha:" name="userName" defaultValue={filters?.userName} />
        </div>
        <div className={styles.selectContainer}>
          <Select
            label="Status API"
            name="statusApi"
            defaultValue={filters?.statusApi}
            options={statusOptions}
            getValue={item => item?.value}
            getLabel={item => item?.label}
          />
        </div>
      </>
    )
  })

  const resetFilters = () => {
    reset(FILTER_DEFAULT_VALUES)
  }

  return (
    <FormProvider {...methods}>
      <SideFilter
        open={open}
        close={close}
        mainFilters={mainFilters}
        cleanFilters={resetFilters}
        applyFilters={handleSubmit(applyFilters)}
      />
    </FormProvider>
  )
}
